import React from 'react';
import { Helmet } from 'react-helmet';
import { withPrefix } from 'gatsby';

const SITE_URL = 'https://ortom.ai';

const Seo = ({ title, description, pathname, image, ogType = 'website', children }) => {
  const canonical = `${SITE_URL}${pathname}`;
  const ogImage = image || `${SITE_URL}${withPrefix('/')}img/logo/Ortom-Logo.png`;

  return (
    <Helmet>
      <html lang="en" />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content={ogType} />
      <meta property="og:locale" content="en_GB" />
      <meta property="og:site_name" content="Ortom Ltd." />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href={`${withPrefix('/')}img/apple-touch-icon.png`}
      />
      <link
        rel="icon"
        type="image/png"
        href={`${withPrefix('/')}img/favicon-32x32.png`}
        sizes="32x32"
      />
      <link
        rel="mask-icon"
        href={`${withPrefix('/')}img/safari-pinned-tab.svg`}
        color="#ff4400"
      />
      <meta name="theme-color" content="#fff" />

      <script data-goatcounter="https://ortom.goatcounter.com/count" async src="//gc.zgo.at/count.js"></script>

      {children}
    </Helmet>
  );
};

export default Seo;
